import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getSupplierLastSelectedStateListData,
  getSupplierLastSelectedStateData,
} from './mockData'
import type { THrid } from '~/types/models'
import type { ISupplierLastSelectedState } from '~/types/supplier/models'

interface GetSupplierLastSelectedStateListDataResponse {
  data: ISupplierLastSelectedState[]
}

async function getSupplierLastSelectedListData(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetSupplierLastSelectedStateListDataResponse = {
    data: await getSupplierLastSelectedStateListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetSupplierLastSelectedStateResponse {
  data: ISupplierLastSelectedState
}

async function getSupplierLastSelectedState(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const responseBody: GetSupplierLastSelectedStateResponse = {
    data: await getSupplierLastSelectedStateData(id),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

interface PostSupplierLastSelectedStateResponse {
  hrid: THrid
}
const postSupplierLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getSupplierLastSelectedStateListData
  )
}

const patchSupplierLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getSupplierLastSelectedStateListData
  )
}

const deleteSupplierLastSelectedState = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getSupplierLastSelectedStateListData
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/supplierlastselectedstates',
    handler: getSupplierLastSelectedListData,
  },
  {
    method: 'get',
    path: '/api/supplierlastselectedstates/:id',
    handler: getSupplierLastSelectedState,
  },
  {
    method: 'post',
    path: '/api/supplierlastselectedstates',
    handler: postSupplierLastSelectedState,
  },
  {
    method: 'patch',
    path: '/api/supplierlastselectedstates/:id',
    handler: patchSupplierLastSelectedState,
  },
  {
    method: 'delete',
    path: '/api/supplierlastselectedstates/:id',
    handler: deleteSupplierLastSelectedState,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
